import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export interface ContactDetailsResponse {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    hasContactDetails: boolean;
}

export interface SaveContactDetailsRequest {
    firstName: string;
    lastName: string;
    email: string;
}

export const getContactDetails = () => {
    const client = createClient(axios);
    return client.get<ContactDetailsResponse>(endpoint('api/v1/contact-details'));
};

export const saveContactDetails = (request: SaveContactDetailsRequest) => {
    const client = createClient(axios);
    return client.post<ContactDetailsResponse>(endpoint('api/v1/contact-details'), request);
};
